export const GODRAYS_RESOLUTION_SCALE = 0.5;
